export default {
  l_Order_tasks: "Тапсырыс бойынша тапсырмалар",
  l_Task: "Тапсырма",
  l_Kind: "Түрі",
  l_Contact_client: "Клиентпен байланыс",
  l_Document_collection: "Құжаттарды жинау",
  l_Not_started: "Басталмаған",
  l_In_progress: "Орындалуда",
  l_Completed: "Аяқталды",
  l_Document_collector: "Жинау әдісі",
  l_Self: "Өзі",
  l_Broker: "Брокер",
  l_Assignee: "Орындаушы",
  l_Deadline: "Мерзімі",
  l_By_orders: "Тапсырыстар бойынша",
  l_List_view: "Тізім",
  l_Filters: "Сүзгілер",
  l_Add_task: "Тапсырма қосу",
  "p_comments:delete": "Пікірлер: Жою",
  "p_comments:edit": "Пікірлер: Өңдеу",
  "p_comments:create": "Пікірлер: Құру",
  "p_comments:view": "Пікірлер: Қарау",

  "p_price+proposals+++delete": "Баға ұсыныстары: Жою",
  "p_price+proposals+++edit": "Баға ұсыныстары: Өңдеу",
  "p_price+proposals+++create": "Баға ұсыныстары: Құру",
  "p_price+proposals+++view": "Баға ұсыныстары: Қарау",

  "p_change+protected+statuses": "Қорғалған статустарды өзгерту",

  "p__request+rate": "Баға сұранымдары",
  "p_delete+requests": "Сұранымдар: Жою",
  "p_editing+requests": "Сұранымдар: Өңдеу",
  "p_create+requests": "Сұранымдар: Құру",
  "p_view+requests": "Сұранымдар: Қарау",

  "p_edit+contact": "Байланыстар: Өңдеу",

  "p_change+credit+limit": "Кредиттік лимит: Өзгерту",

  "p_delete+clients": "Клиенттер: Жою",
  "p_editing+clients": "Клиенттер: Өңдеу",
  "p_create+clients": "Клиенттер: Құру",
  "p_view+clients": "Клиенттер: Қарау",

  "p_delete+carriers": "Тасымалдаушылар: Жою",
  "p_editing+carriers": "Тасымалдаушылар: Өңдеу",
  "p_create+carriers": "Тасымалдаушылар: Құру",
  "p_view+carriers": "Тасымалдаушылар: Қарау",

  "p_documents(transportation,+cmr,+photo):+view":
    "Құжаттар (тасымалдау, CMR, фото): Қарау",

  "p_other:+view": "Басқа: Қарау",
  "p_act:+view": "Акт: Қарау",

  "p_other:+create": "Басқа: Құру",
  "p_other:+delete": "Басқа: Жою",
  "p_other:+edit": "Басқа: Өңдеу",

  "p_acts:+create": "Акттар: Құру",
  "p_acts:+delete": "Акттар: Жою",
  "p_acts:+edit": "Акттар: Өңдеу",

  "p_comments+create": "Пікірлер: Құру",
  "p_comments+edit": "Пікірлер: Өңдеу",
  "p_comments+delete": "Пікірлер: Жою",
  "p_comments+view": "Пікірлер: Қарау",

  "p_view+order+tasks": "Тапсырмалар: Қарау",
  "p_create+order+tasks": "Тапсырмалар: Құру",
  "p_editing+order+tasks": "Тапсырмалар: Өңдеу",
  "p_delete+order+tasks": "Тапсырмалар: Жою",
  "p_all+order+tasks": "Тапсырмалар: Барлығы",

  "p_edit+paid+invoices": "Төленген шоттар: Өңдеу",

  p_delete: "Жою",
  p_edit: "Өңдеу",
  p_create: "Құру",
  p_view: "Қарау",

  "p_edit+paid+invoices_2": "Төленген шоттар: Өңдеу",
  p_delete_2: "Жою",
  p_edit_2: "Өңдеу",
  p_create_2: "Құру",
  p_view_2: "Қарау",

  "p_edit+order+status+history": "Тапсырыс статус тарихы: Өңдеу",
  "p_view+order+status+history": "Тапсырыс статус тарихы: Қарау",

  "p_delete+financial": "Қаржы: Жою",
  "p_edit+financial": "Қаржы: Өңдеу",
  "p_view+financial": "Қаржы: Қарау",

  "p_edit+freight": "Фрахт: Өңдеу",
  "p_view+freight": "Фрахт: Қарау",

  p_margin: "Маржа",
  p_total: "Жалпы",

  "p_trips+in+order": "Тапсырыстағы рейстер",

  "p_documents(transportation,+cmr,+phtoto)":
    "Құжаттар (тасымалдау, CMR, фото)",

  "p_cargo+information": "Жүк туралы ақпарат",
  "p_client+information": "Клиент туралы ақпарат",

  p_profit: "Пайда",

  "p_delete+orders": "Тапсырыстар: Жою",
  "p_edit+status": "Статус: Өңдеу",
  "p_editing+orders": "Тапсырыстар: Өңдеу",
  "p_create+orders": "Тапсырыстар: Құру",
  "p_view+orders": "Тапсырыстар: Қарау",

  "p_delete+trips": "Рейстер: Жою",
  "p_update+trips": "Рейстер: Жаңарту",
  "p_create+trips": "Рейстер: Құру",
  "p_trips+view": "Рейстер: Қарау",

  "p_your+own+departments+orders": "Өз бөлімінің тапсырыстары",
  "p_your+own+orders": "Өз тапсырыстары",
  "p_all+orders": "Барлық тапсырыстар",

  "p_your+own+departments+requests": "Өз бөлімінің сұранымдары",
  "p_your+own+requests": "Өз сұранымдары",
  "p_all+requests": "Барлық сұранымдар",

  "p_your+own+departments+clients": "Өз бөлімінің клиенттері",
  "p_your+own+clients": "Өз клиенттері",
  "p_all+clients": "Барлық клиенттер",

  "p_your+own+departments+carriers": "Өз бөлімінің тасымалдаушылары",
  "p_your+own+carriers": "Өз тасымалдаушылары",
  "p_all+carriers": "Барлық тасымалдаушылар",

  "p_your+own+departments+trips": "Өз бөлімінің рейстері",
  "p_your+own+trips": "Өз рейстері",
  "p_all+trips": "Барлық рейстер",

  "p_view+additional+expenses": "Қосымша шығындар: Қарау",
  "p_create+additional+expenses": "Қосымша шығындар: Құру",
  "p_update+additional+expenses": "Қосымша шығындар: Өзгерту",
  "p_delete+additional+expenses": "Қосымша шығындар: Жою",
  "p_your+own+additional+expenses": "Өз қосымша шығындарым",
  "p_all+additional+expenses": "Барлық қосымша шығындар",
  "p_your+own+departments+additional+expenses":
    "Өз бөлімінің қосымша шығындары",

  l_Username: "Пайдаланушы аты",
  l_User_password: "Құпия сөз",
  l_Forgot_password: "Құпия сөзді қалпына келтіру",
  l_Forgot_password_title: "Құпия сөзді қалпына келтіру",
  l_Enter_email: "Электрондық поштаңызды енгізіңіз",
  l_Send_reset_link: "Сілтеме жіберу",
  l_Back_to_login: "Кіруге оралу",
  l_Reset_link_sent: "Код қайта жіберілді",
  l_Check_email_desc:
    "Егер электрондық пошта болса, қалпына келтіру нұсқаулары поштаңызға жіберілді.",
  l_Code_sent_hint: "Код поштаға жіберілді",
  l_Enter_code: "Хаттан келген кодты енгізіңіз",
  l_Verify_code: "Растау",
  l_Resend_code: "Қайта жіберу",
  l_Back: "Артқа",
  l_New_password: "Жаңа құпия сөз",
  l_Confirm_new_password: "Жаңа құпия сөзді растаңыз",
  l_Reset_password: "Құпия сөзді ауыстыру",
  l_Passwords_not_match: "Құпия сөздер сәйкес келмейді",
  l_Password_reset_success: "Құпия сөз сәтті өзгертілді",
  l_Token_invalid: "Сілтеме жарамсыз немесе мерзімі өтіп кетті",
  l_Verifying_token: "Сілтеме тексерілуде...",
  l_Step_email: "Пошта",
  l_Step_code: "Код",
  l_Step_password: "Құпия сөз",
  l_Login: "Кіру",
  l_Sign_out: "Шығу",
  l_EmailorPasswordisWrong: "Электрондық пошта немесе құпия сөз дұрыс емес",
  l_Requests: "Сұраулар",
  l_Orders: "Тапсырыстар",
  l_Order_code_referral: "Рефералдық код",
  l_Order_code_referral_short: "Реф. код",
  l_Signing_condition: "Қол қою шарты",
  l_Finance: "Қаржы",
  l_Clients: "Клиенттер",
  l_Carriers: "Тасымалдаушылар",
  l_Settings: "Параметрлер",
  l_Organization: "Ұйым",
  l_Templates: "Үлгілер",
  l_Classifiers: "Анықтамалықтар",
  l_System: "Жүйе",
  l_Log: "Лог",
  l_Companies: "Компаниялар",
  l_Departments: "Бөлімдер",
  l_Employees: "Қызметкерлер",
  l_Groups_of_employees: "Қызметкерлер топтары",
  l_Company_name: "Компанияның атауы",
  l_Name_in_original: "Түпнұсқадағы аты",
  l_Company_code: "Компания коды",
  l_VAT_code: "ҚҚС коды",
  l_Business_number: "Типтің номеры",
  l_Address: "Мекенжай",
  l_Address_for_correspondence: "Хат-хабар мекенжайы",
  l_Banks: "Банктер",
  l_Cargo_statuses: "Жүк статустары",
  l_Client_types: "Клиент түрлері",
  l_Document_statuses: "Құжат статустары",
  l_Order_statuses: "Тапсырыс статустары",
  l_Railway_stations: "Темір жол станциялары",
  l_Transport_types: "Транспорт түрлері",
  l_Trip_statuses: "Рейс статустары",
  l_VAT_rates: "ҚҚС тарифтері",
  l_Workers_posts: "Қызметкерлердің лауазымдары",
  l_Whatsapp_notification_send: "WhatsApp арқылы хабарландыру жіберу",
  l_Name: "Аты",
  l_Unofficial_name: "Бейресми аты",
  l_Provide_access_to_carrier: "Тасымалдаушыға көріну",
  l_Branch: "Филиал",
  l_Code__: "МФО (БИК, BLZ)",
  l_Post_code: "Пошта коды",
  l_Action: "Әрекет",
  l_Add: "Қосу",
  l_Update: "Жаңарту",
  l_Edit: "Өңдеу",
  l_Submit: "Жіберу",
  l_Cancel: "Болдырмау",
  l_Are_you_sure_delete_this_task: "Бұл тапсырманы жойғыңыз келе ме?",
  l_Yes: "Иә",
  l_No: "Жоқ",
  l_Keyword: "Кілттік сөз",
  l_Search: "Іздеу",
  l_Active: "Активті",
  l_Deleted: "Жойылған",
  l_Include_deleted: "Жойылғандарды қосу",
  l_Initial: "Бастапқы",
  l_Final: "Соңғы",
  l_Legal_name: "Заңды атауы",
  l_NotFound: "Табылмады",
  l_Succeed: "Операция сәтті өтті",
  l_Segment_name: "Сегмент атауы",
  l_Segment_priority: "Сегмент приоритеті",
  l_Color: "Түс",
  l_By_default: "Әдепкі",
  l_Yellow: "Сары",
  l_Green: "Жасыл",
  l_Grey: "Сұр",
  l_Red: "Қызыл",
  l_Orange: "Қызғылт-сары",
  l_Status_name: "Статус атауы",
  l_Priority: "Приоритеті",
  l_Status_type: "Статус түрі",
  l_Complete_order: "Тапсырысты аяқтау",
  l_Complete_order_confirm:
    "Тапсырысты аяқтау керек пе? Клиентке жүкті алуды растау және қызмет сапасын бағалау қолжетімді болады.",
  l_Text_colour: "Мәтін түсі",
  l_Background_colour: "Фон түсі",
  l_After_setting_status: "Статус орнатылғаннан кейін",
  l_Message_for_seller: "Сатушыға арналған хабарлама",
  l_Topic_of_the_message_for_seller_TWIG:
    "TWIG сатушысына арналған хабарлама тақырыбы",
  l_Name_2: "Атауы",
  l_Railway_station: "Темір жол станциясы",
  l_Code: "Код",
  l_Railway: "Темір жол",
  l_Railway2: "Темір жол транспорты",
  l_Rate: "Тариф",
  l_VAT_law: "ҚҚС туралы заң",
  l_third_party_code: "Бөгде код",
  l___CountVat: "ҚҚС тарифі есепке алынбайды",
  l_Default_VAT_rate: "Әдепкі ҚҚС мөлшерлемесі",
  l_Error: "Қате",
  l_Status_requires_calculation:
    "Бұл мәртебені тек есептеу жасалғаннан кейін өзгерте аласыз!",
  l_Basic_information: "Негізгі ақпарат",
  l_Signatures: "Қолтаңбалар",
  l_Directors_full_name: "Директордың аты-жөні",
  l_In_the_name_of_whom: "Кімнің атынан",
  l_Post: "Лауазым",
  l_VAT_rate: "ҚҚС мөлшерлемесі",
  l_RRC: "КПП",
  l_OGRN: "ОГРН",
  l_Pricing_type: "Бағаны есептеу түрі",
  l_Contact_information: "Заңды мекенжайы",
  l_Country: "Мемлекет",
  l_City: "Қала",
  l_Correspondent_information: "Корреспонденттік ақпарат",
  l_Telephone: "Телефон",
  l_Fax: "Факс",
  l_Email: "Эл.пошта",
  l_Email_text: "Хат мәтіні",
  l_Website: "Веб-сайт",
  l_Main_company: "Негізгі компания",
  l_Operating_account: "Есеп айырысу шоты",
  l_Bank_code: "Банк коды",
  l_Bank: "Банк",
  l_Different_invoices_for_different_currencies:
    "Түрлі валюталар үшін түрлі шот-фактуралар",
  l_Currency: "Валюта",
  l_Correspondent_bank: "Корреспонденттік банк",
  l_Print: "Басып шығару",
  l_Company_logotype: "Компания логотипі",
  l_Signature: "Қолтаңба",
  l_correspondent_account: "Корреспонденттік шот",
  l_Inc_VAT_price: "ҚҚС қосылған баға",
  l_Ex_VAT_price: "ҚҚС қосылмаған баға",
  l_Bank_name: "Банк атауы",
  l_Click_or_drag_ile_to_this_area_to_upload:
    "Файлды жүктеп салу үшін осы аймаққа басыңыз немесе файлды әкеліп қойыңыз",
  l_Department_name: "Бөлім атауы",
  l_Department_prefix: "Бөлім префиксі",
  l_Company: "Компания",
  l_Login_email: "Кіру электрондық поштасы",
  l_Groups: "Топтар",
  l_Name_Surname: "Аты, тегі",
  l_Surname: "Тегі",
  l_Date_of_last_visit: "Соңғы келген күні",
  l_Mail_settings: "Пошта параметрлері",
  l_Password: "Құпия сөз",
  l_Reset_your_password:
    "Құпия сөзді қалпына келтіргіңіз келетініне сенімдісіз бе?",
  l_For_bonus: "бонус үшін %, %",
  l_Employee_prefix: "Қызметкер префиксі",
  l_Department: "Бөлім",
  l_Access_rights: "Құқықтары",
  l_All: "Барлығы",
  l_YourOwnDepartment: "Өз бөлімшесі",
  l_YourOwn: "Тек өзі",
  l_Unlimited_access: "Шексіз құқықтар",
  l_Additional_information: "Қосымша ақпарат",
  l_Auto_pickup: "Авто жинау",
  l_Main: "Негізгі",
  l_Access: "Доступ",
  l_Special_rights: "Арнайы құқықтар",
  l_Group: "Топ",
  l_Numeration: "Нумерация",
  l_Numeration_name: "Нөмірлеу атауы",
  l_Numeration_for: "Нөмірлеу",
  l_Employee: "Қызметкер",
  l_Prefix: "Префикс",
  l_Year: "Жыл",
  l_Month: "Ай",
  l_Delimiter: "Бөлгіш",
  l_Number_of_digits: "Цифрлар саны",
  l_Index: "Индекс",
  l_Suffix: "Суффикс",
  l_View: "Көру",
  l_Client: "Клиент",
  l_Consolidation: "Консолидация",
  l_Cargos: "Жүктер",
  l_TNVED_code: "ТНВЭД коды",
  l_Transport_count: "Транспорт саны",
  l_Transit_date: "Транзит күні",
  l_Dimensions: "Габариттер (Ұ×Е×Б)",
  l_Number_of_places: "Орын саны",
  l_Additional_info: "Қосымша ақпарат",
  l_No_cargo: "Жүктер қосылмаған",
  l_Copy: "Көшіру",
  l_Copy_all: "Барлығын көшіру",
  l_Copied: "Көшірілді",
  l_Copy_failed: "Көшіру сәтсіз аяқталды",
  l_Screenshot: "Скриншот",
  l_Screenshot_copied: "Скриншот көшірілді",
  l_Screenshot_saved: "Скриншот сақталды",
  l_Screenshot_failed: "Скриншот жасау сәтсіз аяқталды",
  l_Trips: "Рейстер",
  l_Cargos_status: "Жүктер статусы",
  l_Salary_calculation: "Жалақыны есептеу",
  l_Show_filters: "Фильтрді көрсету",
  l_Order_date: "Тапсырыс күні",
  l_Status_changed_at: "Мәртебе өзгерту күні",
  l_Date: "Күн",
  l_Users: "Пайдаланушылар",
  l_Documents: "Құжаттар",
  l_Transport: "Транспорт",
  l_Other: "Басқа",
  l_Sort: "Сұрыптау",
  l_Order_number: "Тапсырыс нөмірі",
  l_Order_status: "Тапсырыс статусы",
  l_Loading_area: "Жүктеу аймағы",
  l_Unloading_area: "Жүк түсіру аймағы",
  l_Loading_date: "Жүктеу күні",
  l_Days_of_trip: "Жолдағы күндер",
  l_Car_number: "Көлік нөмірі",
  l_Freight: "Фрахт",
  l_Costs: "Шығындар",
  l_Profit: "Пайда",
  l_User: "Пайдаланушы",
  l_Trip_number: "Рейс нөмірі",
  l_Weight: "Салмағы",
  l_Volume: "Көлемі",
  l_Total_freight: "Жалпы фрахт",
  l_Change_status: "Статусты өзгерту",
  l_XML_unloading: "XML жүктеп алу",
  l_Managers: "Менеджерлер",
  l_Date_of_creation: "Жасалу күні",
  l_Client_type: "Клиент түрі",
  l_TIN_taxpayer_ID_number_VAT: "УНН/ЕГРПОУ/VAT№",
  l_Activity_area: "Қызмет түрі",
  l_OKPO: "ОКПО",
  l_TIN: "ЖСН",
  l_BIN: "БСН",
  l_TRN: "РНН",
  l_RNN: "РНН",
  l_INN: "ИНН",
  l_KPP: "КПП",
  l_IIN: "ЖСН",
  l_Legal_address: "Заңды мекенжайы",
  l_Postal_address: "Пошта мекенжайы",
  l_Payment_rules: "Төлем ережелері",
  l_Credit_limit: "Несие лимиті",
  l_Payment_delay: "Төлемді кейінге қалдыру",
  l_Limit_exceeded: "Лимиттен асу",
  l_Deferred_payment_terms: "Төлемді кейінге қалдыру шарттары",
  l_Email_to_send_documents: "Құжаттарды жіберуге арналған электрондық пошта",
  l_Send_debt_remindings: "Қарыздар туралы ескерту жіберу",
  l_Swift: "Swift",
  l_PleaseEnterName: "Аты-жөніңізді енгізіңіз",
  l_Contact_persons_posts: "Байланыстағы тұлғаның лауазымы",
  l_Contact_person: "Байланыстағы тұлға",
  l_Manager: "Менеджер",
  l_Days_from_the_latest_contract: "Соңғы келісім-шарттан кейінгі күндер",
  l_Order_quantity: "Тапсырыс саны",
  l_Purchase_funnel: "Сату воронкасы",
  l_Purchase_funnel_status: "Сату воронкасының статусы",
  l_Phone: "Телефон",
  l_Creation_date: "Жасалу күні",
  l_Type_of_the_received_document: "Алынған құжат түрі",
  l_Contact_personnel: "Байланыс персоналы",
  l_Company_details: "Компания реквизиттері",
  l_Active_requests: "Активті сұраулар",
  l_Archive_requests: "Мұрағат сұраулар",
  l_Archive: "Мұрағаттау",
  l_Duly_represtnted: "Өкілеттігі",
  l_Use_in_all_documents: "Барлық құжаттарда пайдалану",
  l_Phone_number: "Телефон нөмірі",
  l_Skype: "Skype",
  l_ICQ: "ICQ",
  l_Comments: "Пікірлер",
  l_PasswordNotLessThan6Letters: "Құпия сөзде кемінде 6 таңба болуы керек",
  l_Existed: "Бұрыннан бар",
  l_EmailExisted: "Мұндай электрондық пошта бұрыннан бар",
  l_Clients_order_number: "Клиенттің тапсырыс нөмірі",
  l_Contacts: "Контактілер",
  l_Default_forwarder: "Координатор",
  l_Additional_managers: "Freight coordinator",
  l_Price: "Баға",
  l_Price_with_VAT: "ҚҚС қосылған баға",
  l_Deferred_payment_days: "Төлемді кейінге қалдыру (күндер)",
  l_Deferred_payment_conditions: "Төлемді кейінге қалдыру жағдайы",
  l_Full_text: "Толық мәтін",
  l_One_or_more_content_missing:
    "Контенттің бір немесе бірнеше элементтері жоқ",
  l_Statuses: "Статустар",
  l_Invoices: "Шот-фактуралар",
  l_Tasks: "Тапсырмалар",
  l_Number: "Нөмер",
  l_Initial_freight: "Бастапқы баға",
  l_Expenses: "Шығындар",
  l_Forwarders: "Операторлар",
  l_Documents_with_clients: "Клиенттермен құжаттар",
  l_Cargo_number: "Жүк нөмірі",
  l_Cargo_name: "Жүк атауы",
  l_Cargo_parameters: "Жүк параметрлері",
  l_Loading: "Жүктеу",
  l_Reloading_storage_place: "Қайта жүктеу/сақтау орны",
  l_Date_of_transhipment: "Қайта жүктеу күні",
  l_Unloading: "Жүк түсіру",
  l_Consignment_Price: "Жүк бағасы",
  l_Loading_place: "Жүктеу орны",
  l_Time: "Уақыт",
  l_Place_Company: "Орын / Компания",
  l_Rate_date: "Курс күні",
  l_Contact_person_and_telephone: "Байланыстағы тұлға және телефон",
  l_Loading_place_customs: "Жүктеу кедені",
  l_To: "Дейін",
  l_Unloading_place: "Жүк түсіру орны",
  l_Unloading_place_customs: "Жүк түсіру кедені",
  l_Packing_type_quantity: "Қаптама түрі/саны",
  l_Pallets: "Паллеттер",
  l_LDM: "LDM",
  l_Length: "Ұзындығы",
  l_Width: "Ені",
  l_Height: "Биіктігі",
  l_Partial_cargo: "Жартылай жүк",
  l_Cargo_additional_information: "Жүк туралы қосымша ақпарат",
  l_Attributes: "Атрибуттар",
  l_Insurance: "Сақтандыру",
  l_Terms_of_delivery: "Жеткізу шарттары (Инкотермс 2010 бойынша)",
  l_Transit_Time: "Транзит уақыты",
  l_Status: "Статус",
  l_Unloading_date: "Жүк түсіру күні",
  l_Carrier: "Тасымалдаушы",
  l_Carrier_to_user: "Тасымалдаушыларға қолжетімділік",
  l_Forwarder: "Оператор",
  l_Received_invoices: "Алынған шот-фактуралар",
  l_Cargos_and_Routes: "Жүктер мен Маршруттар",
  l_Carrier_company: "Тасымалдаушы компания",
  l_Carrier_contract_number_with_carrier:
    "Тасымалдаушымен жасалған шарттың нөмірі",
  l_Insurance_policy_valid_until: "Сақтандыру полисінің жарамдылық мерзімі",
  l_Number_in_carriers_system: "Тасымал жүйесіндегі нөмір",
  l_Trip: "Рейс",
  l_Terms_and_conditions_of_payment: "Төлем мерзімі мен шарттары",
  l_Vehicle_number: "Көлік нөмірі",
  l_Trailers_numbers: "Прицеп нөмірі",
  l_Transport_type: "Транспорт түрі",
  l_Loading_method: "Жүктеу әдісі",
  l_Passport_number: "Паспорт нөмірі",
  l_Driver: "Жүргізуші",
  l_Container_number: "Контейнер нөмірі",
  l_Sizes_L_W_H: "Өлшемдері (Ұ*Е*Б)",
  l_Amount: "Саны",
  l_Packing: "Қаптама",
  l_Packing_type: "Қаптама түрі",
  l_Quantity: "Саны",
  l_Container: "Контейнер",
  l_Container_type: "Контейнер түрі",
  l_Container_quantity: "Контейнерлер саны",
  l_Container_ownership: "Контейнер тиесілігі",
  l_Loading_by_carrier: "Тасымалдаушымен тиеу",
  l_Calculation_data: "Есептеу деректері",
  l_Category: "Санат",
  l_Cargo_ready_date: "Жүк дайын болу күні",
  l_Full_conditions: "Толық шарттар",
  l_Create_in_series: "Серияда жасау",
  l_Series: "Серия",
  l_Cargo_properties: "Жүк қасиеттері",
  l_Stackable: "Қатарлауға болады",
  l_Regular_shape: "Дұрыс пішін",
  l_Fragile: "Сынғыш",
  l_Must_be_upright: "Тек тік күйде",
  l_Magnetic: "Магнитті",
  l_Liquid: "Сұйықтық",
  l_Powder: "Ұнтақ",
  l_Contains_battery: "Батарея бар",
  l_Battery_type: "Батарея түрі",
  l_Max_stack_weight: "Макс. қатарлау салмағы",
  l_Order: "Тапсырыс",
  l_Route: "Маршрут",
  l_Cargo_status: "Жүк статусы",
  l_Received_invoice: "Алынған шот-фактура",
  l_Expense: "Шығын",
  l_Expenses_incl_VAT: "ҚҚС қосылған шығындар",
  l_Dont_count_in_balance: "Шығын қаржыда есептелмесін",
  l_Separate_line_in_the_invoice: "Шот-фактурадағы жеке жол",
  l_Expense_description: "Шығындардың сипаттамасы",
  l_Document_name: "Құжат атауы",
  l_Document_expiration_date: "Құжаттың жарамдылық мерзімі",
  l_Available_for_client: "Клиент үшін қол жетімді",
  l_Show_to_client: "Клиентке көрсету",
  l_Type: "Түр",
  l_Template: "Құжат үлгісі",
  l_Attached_file: "Тіркелген файл",
  l_Document_number: "Құжат нөмірі",
  l_Document_date: "Құжат күні",
  l_Provide_access_to_the_client: "Клиентке құқық беру",
  l_File: "Файл",
  l_OverheadDocuments: "Үстеме құжаттар",
  l_Tags: "Тегтер",
  l_Rail_trips: "Темір жол рейстері",
  l_OtherDocuments: "Басқа құжаттар",
  l_Acts: "Актілер",
  l_Photos: "Суреттер",
  l_Link: "Сілтеме",
  l_To_comment: "Пікір қалдыру үшін",
  l_Comment: "Пікір",
  l_Cargo: "Жүк",
  l_Place: "Орын",
  l_ETA: "ETA",
  l_Sent: "Жіберілді",
  l_Author: "Автор",
  l_Trip_type: "Рейс түрі",
  l_Neutral: "Бейтарап",
  l_Finish: "Соңғы",
  l_Change_the_status_of_cargo_on_this_flight:
    "Осы рейстегі жүктердің статусын өзгерту",
  l_Are_you_sure_you_want_to_update: "Жаңартқыңыз келетініне сенімдісіз бе?",
  l_Return_for_revision: "Қайта өңдеуге қайтару",
  l_Return_reason: "Қайтару себебі",
  l_Enter_return_reason: "Қайтару себебін енгізіңіз",
  l_Return_reason_required: "Қайтару себебі міндетті",
  l_Finance_template: "Қаржы үлгісі",
  l_Wagon_data: "Вагон деректері",
  l_Train_Trip_number: "Поезд/рейс нөмірі",
  l_Car_Container_number: "Вагон/контейнер нөмірі",
  l_Cargo_data: "Жүк деректері",
  l_GNG_code: "ГНГ код",
  l_Classes_of_transport_rates: "ЕТСНГ",
  l_Rules_for_using_the_car: "Автокөлікті пайдалану ережелері",
  l_Wagon_renter: "Вагонды жалға алушы",
  l_Freight_with_VAT: "ҚҚС қосылған фрахт",
  l_Login_: "Кіру",
  l_Close: "Жабу",
  l_Directions: "Бағыттар",
  l_From: "Бастап",
  l_Countries: "Мемлекеттер",
  l_Drivers_name: "Жүргізушінің аты",
  l_Drivers_surname: "Жүргізушінің тегі",
  l_Middle_name: "Жүргізушінің әкесінің аты",
  l_Passport: "Паспорт",
  l_Driving_licence_number: "Жүргізуші куәлігінің нөмірі мен сериясы",
  l_Driving_licence_categories: "Жүргізуші куәлігінің санаттары",
  l_Fuel_card: "Жанармай картасы",
  l_Is_active: "Белсенді",
  l_Bank_account: "Банк шоты",
  l_Contact_type: "Байланыс түрі",
  l_Vehicle: "Көлік",
  l_Specifications: "Техникалық сипаттамалар",
  l_updateStatus: "Статус жаңарту",
  l_Date_of_employment: "Жұмысқа қабылдау күні",
  l_Euro_emission_class: "Экологиялық сынып",
  l_Trailer_number: "Прицеп нөмірі",
  l_Brand: "Марка",
  l_Model: "Модель",
  l_Production_date: "Өндірілген күні",
  l_Body_number: "Кузов нөмірі",
  l_Registration_date: "Тіркеу күні",
  l_Tech_passport_validity: "Техникалық паспорттың жарамдылық мерзімі",
  l_License_number: "Лицензия нөмірі",
  l_License_validity_date: "Лицензияның жарамдылық мерзімі",
  l_Drivers: "Жүргізушілер",
  l_Transport_information: "Транспорт деректері",
  l_Vehicle_empty_weight: "Көліктің таза салмағы",
  l_Vehicle_full_weight: "Көліктің толық салмағы",
  l_Vehicle_axels: "Көлік осьтері",
  l_Max_weight: "Максималды жүктеу салмағы",
  l_Max_euro_pallets: "Максималды еуро паллеттер саны",
  l_Relevant_documents: "Тиісті құжаттар",
  l_Document_groups: "Құжаттар топтары",
  l_Template_name: "Тасымалдау атауы",
  l_Is_default: "Әдепкі ме",
  l_Service_type: "Қызмет түрі",
  l_Statistical: "Статистикалық",
  l_Statistic: "Статистика",
  l_Unregistered: "Тіркелмеген",
  l_Role: "Рөл",
  l_Permission: "Рұқсат",
  l_Description: "Сипаттама",
  l_Services: "Қызметтер",
  l_Peromission_key: "Рұқсат кілті",
  l_Parent_option: "Тектік параметр",
  l_Level: "Деңгей",
  l_Border_point: "Шекара нүктесі",
  l_Cost_per_cargo: "Жеке жүктің құны",
  l_By_weight: "Салмағы бойынша",
  l_By_volume: "Көлемі бойынша",
  l_By_weight_and_volume: "Салмағы және көлемі бойынша",
  l_Batch_setting_cargo_status: "Жүк статусын пакеттік орнату",
  l_Select: "Таңдаңыз",
  l_Selected: "Таңдалған",
  l_not_selected: "Таңдалмаған",
  l_Distribute_percent: "Үлестіру пайызы",
  l_Distribute_price: "Үлестіру бағасы",
  l_Total: "Барлығы",
  l_Clear: "Тазалау",
  l_By: "Бойынша",
  l_Add_date: "Күнді қосу",
  l_Update_date: "Жаңарту күні",
  l_Descending: "Кемуі бойынша",
  l_Ascending: "Өсуі бойынша",
  l_Invoice: "Шот-фактура",
  l_Invoices_issued: "Шығарылған шот-фактуралар",
  l_invoiceNumber: "Шот-фактура нөмірі",
  l_senderInvoice: "Компания",
  l_issuedDate: "Шот-фактура шығарылды",
  l_receivingDate: "Алынған күні",
  l_payUntilDate: "Төлеудің соңғы күні",
  l_Trip_status: "Рейс статусы",
  l_Without_VAT: "ҚҚС қосылмаған",
  l_With_VAT: "ҚҚС қосылған",
  l_Invoice_line: "Шот-фактура жолы",
  l_Unit: "Бірлік",
  l_Received_from: "Беруші",
  l_Company_which_received_the_invoice: "Шот-фактураны алған компания",
  l_Breaking_rule: "Сұрыптау ережесі",
  l_Contractor: "Орындаушы",
  l_Payer: "Төлеуші",
  l_Language: "Тіл",
  l_Made: "Жасаған",
  l_Notes: "Ескертпелер",
  l_Devider: "Бөлгіш",
  l_Element: "Элемент",
  l_Percent: "Пайыз",
  l_INN_EGRPOU_VAT_BIN_UNN: "ИНН, ЕГРПОУ, VAT, БИН, УНН",
  l_Start: "Бастау",
  l_End: "Соңы",
  l_Contract_date: "Келісімшарт күні",
  l_Contract_number: "Келісімшарт нөмірі",
  l_Has_contract: "Келісімшарт бар",
  l_Contragents: "Контрагенттер",
  l_Issued_invoice_in_order: "Тапсырыс берілген шот-фактура",
  l_Status_history: "Статустар тарихы",
  l_New_request: "Жаңа клиент қосу",
  l_Notification_language: "Хабарлама жіберу тілі",
  l_Classifier_section: "Нұсқаулық бөлімі",
  l_Client_type_definition:
    "Клиент түрлері - маңыздылығы/шұғылдығы бойынша Клиенттердің жіктелуі Клиент картасында толтырылады және Сұраныстармен әрекеттеседі. Каталогты толтыру кезінде сегменттің басымдылығын орнатуға болады. Бұл сан осы түрі бар клиенттен сұраудың маңыздылығы мен орнын анықтайды. Ол келесідей жұмыс істейді: каталогқа VIP клиент түрін қосыңыз, сегмент басымдығы 1. Әрі қарай, қалаған Клиенттің картасында осы түрді таңдаңыз және осы Клиенттің барлық сұраулары жалпы Сұраныс кестесінің ең жоғарғы жағында орналасады, қабылдау тәртібіне қарамастан. Сондай-ақ, белгілі бір түрдегі Клиенттер бойынша таңдау жасау үшін Клиенттер блогында сүзгіні пайдалануға болады.",
  l_Company_is_required: "Компанияны таңдаңыз",
  l_File_is_required: "Файлдарды жүктеңіз",
  l_Comment_is_required: "Пікіріңізді енгізіңіз",
  l_Document_name_is_required: "Құжат атауын енгізіңіз",
  l_Company_name_is_required: "Компания атауын енгізіңіз",
  l_Expense_name_required_without_template: "Үлгі таңдалмаса, атауы міндетті",
  l_Business_number_is_required: "Нөмірді енгізіңіз",
  l_Required_field: "Міндетті өріс",
  l_Select_required: "Таңдаңыз",
  l_Transfer_client: "Клиентті ауыстыру",
  l_Transfer: "Ауыстыру",
  l_Transfer_history: "Ауыстыру тарихы",
  l_New_manager: "Жаңа менеджер",
  l_From_manager: "Менеджерден",
  l_To_manager: "Менеджерге",
  l_Performed_by: "Орындаған",
  l_Selected_clients: "Таңдалған клиенттер",
  l_Refresh: "Жаңарту",
  l_System_break: "Жүйелік үзіліс",
  l_Active_break: "Белсенді үзіліс",
  l_No_active_break: "Белсенді үзіліс жоқ",
  l_Break_reason: "Үзіліс себебі",
  l_Break_reason_placeholder: "Мыс.: Түскі үзіліс",
  l_Break_reason_required: "Үзіліс себебін көрсетіңіз",
  l_Break_from: "Басталу уақыты",
  l_Break_to: "Аяқталу уақыты",
  l_Break_time_required: "Бастау және аяқтау уақытын көрсетіңіз",
  l_Break_started_by: "Бастаған қолданушы",
  l_Add_break: "Үзіліс қосу",
  l_Start_break: "Үзілісті бастау",
  l_Stop_break: "Үзілісті аяқтау",
  l_Stop_break_confirm:
    "Үзілісті мерзімінен бұрын аяқтағыңыз келетіні сенімдісіз бе?",
  l_System_on_break: "Жүйе үзілісте",
  l_Break_ends_at: "Үзіліс аяқталады",
  l_Break_history: "Үзілістер тарихы",
  l_Finished: "Аяқталды",
  l_Generate_sno: "СНО қалыптастыру",
  l_Create: "Құру",
  l_General_invoice: "Жалпы шот",
  l_Create_general_invoice: "Жалпы шотты қалыптастыру",
  l_General_invoice_created: "Жалпы шот құрылды",
  l_General_invoice_create_error: "Жалпы шотты құру мүмкін болмады",
  l_Download_avr: "АВР жүктеу",
  l_Download_realization: "Өткізуді жүктеу",
  l_OneC_document_not_ready: "1С құжатты әлі жіберген жоқ",
  l_Split_into_tranches: "Төлем транштарына бөлу",
  l_First_tranche: "Бірінші транш, %",
  l_Second_tranche: "Екінші транш, %",
  l_Rate_source: "USD бағам көзі",
  l_Nbrk_rate: "ҚР ҰБ бағамы",
  l_Forte_rate: "Форте",
  l_Manual_rate: "Қолмен енгізілген бағам",
  l_Sno_auto_updated: "Автоматты жаңартылды",
  l_Paid_by_1c: "1С деректері бойынша төленді",
  l_From_date: "күні",
  l_Document: "құжат",
  l_Rate_source_change_hint:
    "Шот таңдалған көздің бағамы бойынша қайта есептеліп, 1С-ке қайта жіберіледі. Шот бойынша төлем болса — өзгерту мүмкін емес.",
  l_Rate_source_change_separately:
    "Бағам көзін өзгерту — жеке әрекет: алдымен басқа түзетулерді сақтаңыз, содан кейін шоттар тізімінде бағам көзін өзгертіңіз.",
  l_Approve: "Мақұлдау",
  l_Download_xlsx: "XLSX жүктеу",
  l_Download_pdf: "PDF жүктеу",
  l_Manual_exchange_rates: "Қолмен USD бағамдары",
  l_Usd_kzt_rate: "Теңгенің долларға бағамы (KZT/USD)",
  l_Rate_kzt_per_usd: "Бағам, 1 $ үшін ₸",
  l_Add_rate: "Бағам қосу",
  l_File_not_ready: "Шот файлы әзірге дайын емес, кейінірек қайталаңыз",
  l_Specify_both_tranches: "Екі транш үшін де пайызды көрсетіңіз",
  l_Select_payer: "Төлеушіні таңдаңыз",
  l_Select_vat_rate: "ҚҚС мөлшерлемесін таңдаңыз",
  l_Add_at_least_one_line: "Кемінде бір шот жолын қосыңыз",
  l_Fill_line_description: "Барлық шот жолдарында сипаттаманы толтырыңыз",
  l_Invalid_line_amount: "Шот жолдарында дұрыс санды көрсетіңіз",
  l_Invalid_line_price: "Шот жолдарында дұрыс бағаны көрсетіңіз",
  l_Status_requires_review: "Тексеруді қажет етеді",
  l_Status_approved: "Мақұлданды",
  l_Status_sent_to_1c: "1С-ке жіберілді",
  l_Status_sent_to_client: "Клиентке жіберілді",
  l_Status_completed_by_1c: "1С-те өңделді",
  l_Status_awaiting_payment: "Төлемді күтуде",
  l_Status_partially_paid: "Ішінара төленді",
  l_Status_paid: "Төленді",
  l_Status_realized: "Өткізілді",
  l_Status_error_from_1c: "1С қатесі",
  l_Status_resent_to_1c: "1С-ке қайта жіберілді",
  l_Resubmit_sno_note: "Клиент карточкасындағы жаңартылған төлеуші деректерімен сол СНО жіберіледі. Өзгертілген сомалар мен жолдар жіберілмейді.",
  l_Sno_already_sent_to_1c: "СНО 1С-ке жіберіліп қойған",
  l_Sno_not_sent_to_1c_yet: "СНО әлі 1С-ке жіберілмеген — алдымен оны мақұлдаңыз",
  l_OneC_error_contract_hint: "Бухгалтер 1С-те осы валютадағы шартты енгізуі керек, не СНО валютасын KZT-ге ауыстырыңыз",
  l_OneC_error_bin_not_found: "Төлеушінің БСН-і 1С-те табылмады",
  l_OneC_error_required_field_missing: "Міндетті өріс толтырылмаған",
  l_OneC_error_invalid_template: "СНО үлгісі дұрыс емес",
  l_OneC_error_document_not_found: "Құжат 1С-те табылмады",
  l_OneC_error_document_update_error: "1С-те құжатты жаңарту қатесі",
  l_OneC_error_internal: "1С ішкі қатесі",
  l_OneC_error_bin_hint: "Клиент карточкасындағы БСН-ді (12 сан) тексеріп, СНО-ны қайта жіберіңіз",
  l_Open_payer_card: "Төлеуші карточкасы",
  l_Field: "Өріс",
  l_Resubmit_sno: "1С-ке қайта жіберу",
  l_Version: "Нұсқа",
  l_Sno_history: "СНО тарихы",
  l_Version_actual: "Өзекті",
  l_Version_replace_reason: "Ауыстыру себебі",
  l_New_version_warning:
    "Өзгертуден кейін құжаттың жаңа нұсқасы жасалады. Алдыңғы нұсқа тарихта сақталады.",
  l_Sno_not_formed: "СНО әлі қалыптастырылмаған — өзгерту қолжетімсіз",
  l_Avr: "АВР",
  l_Generate_avr: "АВР қалыптастыру",
  l_Avr_required: "АВР қажет",
  l_Avr_type: "АВР түрі",
  l_Avr_electronic: "Электрондық",
  l_Avr_paper: "Қағаз",
  l_Avr_status_not_requested: "Сұралмаған",
  l_Avr_status_requested: "Сұралды",
  l_Avr_status_in_progress: "Жұмыста",
  l_Avr_status_formed: "Қалыптастырылды",
  l_Avr_status_error: "Қате",
  l_Open: "Ашу",
  l_Download: "Жүктеу",
  l_Client_bin: "Клиенттің БСН-і",
  l_Already_formed: "Қалыптастырылған",
  l_Select_all: "Барлығын таңдау",
  l_Deselect_all: "Таңдауды алып тастау",
  l_All_electronic: "Барлығына «Электрондық»",
  l_All_paper: "Барлығына «Қағаз»",
  l_Avr_bulk_confirm:
    "Таңдалған өтінімдер бойынша ({n}) бухгалтерге АВР қалыптастыру сұрауын жіберу керек пе?",
  l_Request_sent: "Сұрау жіберілді",
  l_Result: "Нәтиже",
  l_Nothing_selected: "Бірде-бір өтінім таңдалмаған",
  l_Updated_by: "Кім өзгертті",
  l_Updated_at: "Өзгертілген күні",
  l_Tranche: "Транш",
  l_Save_as_template: "Үлгі ретінде сақтау",
  l_Template_saved: "Үлгі сақталды",
  l_Delete_template_confirm: "Үлгіні жою керек пе?",
  l_Delete: "Жою",
  l_Delete_invoice_confirm: "Шотты жою керек пе?",
  l_Template_name_optional: "Атауы (міндетті емес)",
  l_Editing: "Өңдеу",
  l_CN_operators: "Операторлар",
  l_CN_operator: "Оператор",
  l_Freight_coordinators: "Freight coordinators",
  l_Freight_coordinator: "Freight coordinator",
  l_Logisticians: "Логистер",
  l_Manager_assignment_templates: "Менеджерлерді байланыстыру үлгілері",
  l_Product_type_assignment_templates: "Өнім түрлерін байланыстыру үлгілері",
  l_Already_assigned: "бұрын байланыстырылған",
  l_Product_type_already_assigned:
    "Өнім түрлері басқа үлгіге байланыстырылған: {items}",
  l_Exchange_rates: "Валюта бағамдары",
  l_Forte_rates: "ForteBank бағамдары",
  l_Rate_sell: "Сату бағамы",
  l_Fetched_at: "Forte-ден алынды",
  l_Forte_rate_not_found: "Таңдалған күнге бағам табылмады",
  l_Forte_rate_not_found_hint:
    "Бағамдарды күн сайынғы джоба шамамен 09:00-де сақтайды, сондықтан болашақ күндерге және ол іске қосылғанға дейін бүгінгі күнге дерек болмайды. CNY валютасы мүлдем жиналмайды.",
  // Өтінім құжаттарын растау
  l_Approval_status: "Растау мәртебесі",
  l_Doc_status_todo: "Жіберілмеген",
  l_Doc_status_review: "Тексерілуде",
  l_Doc_status_approved: "Расталды",
  l_Doc_status_rejected: "Қабылданбады",
  l_Doc_status_uploaded_by_client: "Клиент жүктеді",
  l_Doc_status_approved_by_client: "Клиент растады",
  l_Confirm_document: "Құжатты растау",
  l_Reject_document: "Құжатты қабылдамау",
  l_Rejection_reason: "Қабылдамау себебі",
  l_Enter_rejection_reason: "Мысалы: скан оқылмайды, қайта жіберіңіз",
  l_Rejection_reason_required: "Қабылдамау себебін көрсетіңіз",
  // Клиенттен ақпарат сұрау
  l_Request_info_from_client: "Клиенттен ақпарат сұрау",
  l_Info_requested_from_client: "Ақпарат сұралды",
  l_Edit_info_request: "Ақпарат сұрауын өзгерту",
  l_What_is_needed: "Клиенттен не қажет",
  l_Info_request_comment_placeholder: "Мысалы: мөлшерлемені есептеу үшін қажет",
  l_Reminders: "Еске салулар",
  l_Waiting_answer: "Жауап күтілуде",
  l_Closed: "Жабылды",
  l_Close_request: "Сұрауды жабу",
  l_Are_you_sure_delete_info_request: "Ақпарат сұрауын жою керек пе?",
  l_Info_item_packing_list: "Қорап санымен қаптама парағы",
  l_Info_item_invoice: "Инвойс",
  l_Info_item_tnved_code: "ТН ВЭД коды",
  l_Info_item_cargo_photo: "Жүк / паллет фотосы",
  l_Info_item_specification: "Артикулдар бойынша спецификация",
  l_Cadence_off: "Еске салмау",
  l_Cadence_6h: "Әр 6 сағат сайын",
  l_Cadence_12h: "Әр 12 сағат сайын",
  l_Cadence_24h: "Әр 24 сағат сайын",
  l_Cadence_48h: "Әр 48 сағат сайын",
  l_Cadence_72h: "Әр 72 сағат сайын",
  l_Cadence_off_hint: "Клиентке еске салулар жіберілмейді",
  // Барлық ақпарат сұрауларының тізімі
  l_Info_requests: "Ақпарат сұраулары",
  l_Request_number: "Сұрау нөмірі",
  l_Request_status: "Сұрау мәртебесі",
  l_Created: "Жасалған уақыты",
  l_Partially_answered: "Жауап ішінара",
  l_Answered_at: "Жауап алынды",
  l_Requested_by: "Сұраған",
  l_Requested_at: "Сұралды",
  l_Client_answered: "Клиент жауап берді",
  l_Any: "Маңызды емес",
  l_Preset_waiting_client: "Клиент жауабын күтудеміз",
  l_Preset_partially_answered: "Ішінара жауап берді",
  l_Preset_all_active: "Барлық белсенді",
  l_Info_request_pending_items: "Клиенттен күтеміз",
  // Клиенттің баға ұсынысына жауабы
  l_Client_response: "Клиент жауабы",
  l_Client_accepted: "Қабылданды",
  l_Client_declined: "Қабылданбады",
  l_Client_comment: "Клиент түсініктемесі",
  l_No_answer_yet: "Жауап жоқ",
  l_Sales_plans: "Сату жоспарлары",
  l_Plan_type: "Жоспар түрі",
  l_Plan_type_KNR: "ҚХР жоспары",
  l_Plan_type_EUROPE: "Еуропа жоспары",
  l_Monthly_targets: "Ай сайынғы мақсаттар",
  l_Yearly_target: "Жылдық мақсат",
  l_Yearly_target_hint:
    "ай сайынғы мақсаттардың қосындысы, автоматты есептеледі",
  l_Months_filled: "Толтырылған айлар",
  l_Scope: "Көрсету",
  l_My_plans: "Менің жоспарларым",
  l_All_plans: "Барлық жоспарлар",
  l_Calls_count: "Қоңыраулар саны",
  // Тапсырыс құжаттары: клиентпен келісу (.todo/order-updates.md)
  l_Save: "Сақтау",
  l_Draft_type: "Драфт түрі",
  l_Draft_type_cmr: "CMR",
  l_Draft_type_rwb: "RWB",
  l_Draft_type_awb: "AWB",
  l_Draft_type_declaration: "Экспорттық декларация",
  l_Document_type: "Құжат түрі",
  l_Request_from_client: "Клиенттен сұрау",
  l_Request_reason: "Сұрау себебі (оны клиент көреді)",
  l_Template_for_client: "Клиентке арналған үлгі",
  l_Save_and_send_to_client: "Сақтап, клиентке жіберу",
  l_Send_to_client: "Клиентке жіберу",
  l_Reupload_document: "Құжатты қайта жүктеу",
  l_Upload_own_version: "Өз нұсқаңызды жүктеу",
  l_Waiting_for_client: "Клиентті күтудеміз",
  l_Your_turn: "Сіздің кезегіңіз",
  l_Send_again: "Қайта жіберу",
  l_Client_file: "Клиенттің файлы",
  l_Replace_template: "Үлгіні ауыстыру",
  l_Template_client_hint: "Клиент үлгіні көреді, толтырылған өз файлын тіркеп, келісуге қайтарады. Файл клиентке сол күйінде, кез келген форматта жіберіледі — PDF, DOCX, XLSX, скан.",
  l_Template_reupload_hint: "Жаңа файл үлгіні ауыстырады, клиенттің файлы тазаланады, кезек клиентке қайтады.",
  l_Doc_error_pending_manager: "Құжат тексеруде",
  l_Doc_error_not_pending_manager:
    "Қазір клиенттің кезегі — келісу қолжетімсіз",
  l_Doc_error_already_approved: "Құжат келісілген, өзгертуге болмайды",
  l_Doc_error_file_required: "Кемінде бір файл тіркеңіз",
  l_Doc_error_not_found: "Құжат табылмады, тізім жаңартылды",
  l_Created_by_client: "Клиент жасаған",
  l_Created_by_client_hint: "Өтінімді клиент жеке кабинетте жасаған",
  l_Client_returned: "Клиент қайтарды",
  l_Catalog_technical_description: "Техникалық сипаттама",
  l_Catalog_intended_use: "Қолдану саласы",
  l_Catalog_declaration_conformity: "Сәйкестік декларациясы",
  l_Catalog_knb_approval: "ҰҚК қорытындысы",
  l_Catalog_rgi_approval: "РГИ қорытындысы",
  l_Catalog_miid_approval: "ИИДМ қорытындысы",
  l_Catalog_ses_exemption: "СЭС бас тарту хаты",
  l_Catalog_state_registration: "МТК (СГР)",
  l_Catalog_registration_certificate: "Тіркеу куәлігі (РУ)",
  l_Catalog_import_license: "Импорт лицензиясы",
  l_Catalog_knb_notification: "ҰҚК нотификациясы",
  l_Catalog_invoice: "Инвойс",
  l_Catalog_packing_list: "Қаптама парағы",
  l_Catalog_authenticity: "Дұрыстығы",
  l_Catalog_other: "Басқа",
  l_Request_document_from_client: "Клиенттен құжат сұрату",
  l_Sure_send_to_client: "Құжатты клиентке жіберу керек пе?",
  l_Sure_confirm_document: "Клиент құжатын растау керек пе?",
  l_Responded_at: "Клиент жауабы",
  // Обязательные документы клиента (.todo/mandatory-client-documents-fe.md)
  l_Mandatory_document: "Міндетті",
  l_Mandatory_document_hint:
    "Құжат клиент үшін міндетті: жоюға және түрін өзгертуге болмайды",
  // Согласование цены (.todo/price-negotiation-api.md)
  l_Price_negotiation: "Бағаны келісу",
  l_No_price_negotiation: "Бағаны келісу әлі басталған жоқ",
  l_Calculation: "Есептеу",
  l_Client_decision_review: "Қаралуда",
  l_Client_decision_accepted: "Клиент келісті",
  l_Client_decision_declined: "Клиент қабылдамады",
  l_Client_proposals: "Клиенттің қарсы ұсыныстары",
  l_Client_proposed_price: "Клиент бағасы",
  l_Offered_price: "Менеджер ұсынған баға",
  l_Agreed_price: "Келісілген баға",
  l_Status_code: "Мәртебе коды",
  l_Feedback_reasons: "Тапсырысты бағалау себептері",
  l_Positive: "Оң",
  l_Negative: "Теріс",
  // Онбординг клиента: гайды по продуктам (.todo/client-onboarding.md)
  l_Product_guides: "Өнімдер бойынша нұсқаулықтар",
  l_Guide_text: "Нұсқаулық мәтіні",
  l_Only_active: "Тек белсенділер",
  l_Guide_category_air: "Әуе",
  l_Guide_category_train: "Т/Ж",
  l_Guide_category_auto: "Авто",
  l_Guide_category_auto_eu: "Авто (ЕО)",
  l_Guide_category_kz_kz: "Ішкі (ҚР)",
  l_Requires_signature: "Қол қоюға арналған шарт",
  l_Awaiting_signature: "Қол қоюда",
  l_Signed: "Қол қойылған",
  l_Export_cooldown_hint:
    "Жүктеу қазірдің өзінде іске қосылды. {n} сек. кейін қайталауға болады.",
  // Құжат нұсқаларының тарихы (DocumentRevision)
  l_Document_history: "Құжат нұсқаларының тарихы",
  l_Uploaded_at: "Жүктелген күні",
  l_Uploaded_by: "Кім жүктеді",
  l_Waybill_number: "RWB/AWB/CMR",
  l_Ttn_number: "ТТН нөмірі",
  l_Vehicle_or_container_number: "Көлік / контейнер нөмірі",
  l_Borders: "Шекаралар",
  l_Calculation_accepted_by_client_locked:
    "Баға ұсынысы клиентпен келісілген және бекітілген. Өзгерту үшін клиентпен қайта келісу қажет.",
  l_Shortfall_invoice: "Қосымша шот (жетіспеушілік)",
  l_Create_shortfall_invoice: "Қосымша шотты шығару",
  l_Shortfall_invoice_created: "Қосымша шот құрылды",
  l_Shortfall_invoice_error: "Қосымша шотты құру мүмкін болмады",
  l_Shortfall_invoice_source: "Шоттар бойынша жетіспеушілік: {invoices}",
  l_Shortfall_invoice_source_unknown: "Төленген шоттар бойынша жетіспеушілік",
  l_Shortfall_to_pay: "Төлеуге қалды",
  l_Shortfall_amount: "Мөлшерлеме жетіспеушілігі (қосымша шот керек)",
  l_Exchange_rate_source: "Бағам көзі",
  l_Exchange_rate_value: "Бағам",
  l_Manual_rate_hint:
    "Таңдалған валютаның 1 бірлігі үшін теңге; бос болса — анықтамалықтағы бағам",
  l_Manual_rate_hint_kzt:
    "Теңгедегі шот үшін — тапсырыс мөлшерлемесі валютасының бағамы (1 бірлік үшін теңге); бос болса — анықтамалықтағы бағам",
  l_Forte_only_usd_hint:
    "FORTE тек USD үшін қолданылады, басқа валюталар үшін — ҚР ҰБ",
  l_Invalid_manual_rate: "Бағам нөлден үлкен болуы керек",
  l_Currency_and_rate: "Валюта және бағам",
  l_Invoice_resend_1c_warning: "Шот қайта есептеліп, 1С-ке қайта жіберіледі",
  l_Close_avr: "АВР-ды жабу",
  l_Close_avr_confirm: "Тапсырыс бойынша АВР-ды жабу керек пе?",
  l_Close_avr_bulk_confirm: "Таңдалған тапсырыстар бойынша АВР-ды жабу керек пе ({n})?",
  l_Avr_close_title: "АВР-ды жабу",
  l_Avr_closed_info: "АВР жабылды {date}",
  l_Avr_close_success: "АВР жабылды",
  l_Avr_close_summary: "Жабылды: {closed}, өткізілді: {skipped}",
  l_Avr_close_errors: "Қателер:",
  l_Avr_close_no_permission: "АВР-ды жабуға құқық жоқ",
  l_Client_doc_type_contract: "Келісімшарт",
  l_Client_doc_type_other: "Басқа",
  l_Not_specified: "Көрсетілмеген",
  l_Document_type_is_required: "Құжат түрін таңдаңыз",
  l_Client_has_no_contract: "Клиентте келісімшарт жоқ — клиент карточкасында «Келісімшарт» түріндегі құжатты жүктеңіз",
  l_Go_to_client_card: "Клиент карточкасына өту",
  l_Comments_all: "Барлығы",
  l_Comments_with_client: "Клиентпен",
  l_Comments_internal: "Ішкі",
  l_Comments_with_client_hint: "Клиент бұл пікірлерді жеке кабинетінде көреді",
  l_Comments_internal_hint: "Тек қызметкерлерге көрінеді — клиент көрмейді",
  l_Comments_empty: "Әзірге пікірлер жоқ",
  l_Comments_empty_with_client: "Клиентке әзірге ештеңе жазылмаған",
  l_Comments_empty_internal: "Әзірге ішкі пікірлер жоқ",
  l_Visible_to_client: "Клиент көреді",
  l_Visible_to_carrier: "Тасымалдаушы көреді",
  l_Internal_comment: "Ішкі",
  l_Author_client: "Клиент",
  l_Author_carrier: "Тасымалдаушы",
  l_Author_employee: "Қызметкер",
  l_Role_admin: "Админ",
  l_Role_manager: "Менеджер",
  l_Role_china_manager: "Қытай менеджері",
  l_Role_logist: "Логист",
  l_Role_product: "Продакт",
  l_Role_accountant: "Бухгалтер",
  l_Role_broker: "Брокер",
  l_You: "Сіз",
};
